import { Heading } from "@chakra-ui/react";
import React from "react";
import { Link } from "react-router-dom";
import "./contact.css";
import { TfiLinkedin } from "react-icons/tfi";
import {FiPhone } from "react-icons/fi";
import {HiOutlineMail } from "react-icons/hi";
import { Feedback } from "./Feedback";
import { GoMarkGithub } from "react-icons/go";
// import { FaSquareGitlab } from "react-icons/fa6";
import { AiFillGitlab } from "react-icons/ai";

const Contact = () => {
  return (
    <>
     <Heading  color="white">Contact</Heading>
      {/* <Heading color="red.900">Contact</Heading> */}
      <div  id="contactMain">
      <div
     
     style={{
       backgroundColor: "black",
       width: "90%",
       padding: "20px",
      
     }}
   >
     {/* <Heading color="white">Contact</Heading> */}
     <div id="contact" style={{display:"flex",justifyContent:"center",width:"auto"}} >
       <div >
         <Link
           target="_blank"
           to={"https://www.linkedin.com/in/sachin-kesarwani-079002247/"}
           id="contact-linkedin"
         >
           <div id="divoftag1">
            <TfiLinkedin color="green" fontSize={"25px"}/>
            
             <Heading as="h4" marginLeft={"4"} color={"white"} size="md">
               Linkdin
             </Heading>
           </div>
         </Link>

         <Link target="_blank" to={"https://github.com/Sachin-Kesarwani"}>
           <div id="divoftag2" style={{ display: "flex"}}>
            <GoMarkGithub  color="green" fontSize={"25px"}/>
           
            
             <Heading as="h4" marginLeft={"4"} size="md">
               Github
             </Heading>
           </div>
         </Link>
         <Link target="_blank" to={"https://gitlab.com/Sachin_Kesarwani"}>
           <div id="divoftag2" style={{ display: "flex"}}>
            {/* <GoMarkGithub  color="green" fontSize={"25px"}/> */}
           
            <AiFillGitlab color={"green"}  fontSize={"25px"}/>

             <Heading as="h4" marginLeft={"4"} size="md">
               Gitlab
             </Heading>
           </div>
         </Link>
         <div style={{width:"350px",marginLeft:"auto"}}>
     <Heading my={4} _hover={{border:"0.5px solid green"}} w={"50%"} display={"flex"} padding={"5px"} borderRadius={"8px"}  textAlign={"left"} color="green"   as="h3" size="sm" id="contact-phone">
     
     <FiPhone fontSize={"25px"}/>  {" "}<span style={{color:"white",marginLeft:"8px"}}> +91-8470980680</span> 
     </Heading>
     <Heading  _hover={{border:"0.5px solid green"}} w={"90%"} display={"flex"} padding={"5px"} borderRadius={"8px"}  textAlign={"left"} color="green"  as="h3" size="sm" id="contact-email">
   <HiOutlineMail  fontSize={"25px"}/> {" "} <span style={{color:"white",marginLeft:"8px"}}> sachin.kesarwani67890@gmail.com</span>   
     </Heading>
     </div>
       </div>
     </div>
     {/* <div style={{width:"350px",marginLeft:"auto"}}>
     <Heading my={4}  display={"flex"}  textAlign={"left"} color="green"   as="h3" size="sm" id="contact-phone">
     
     <FiPhone fontSize={"25px"}/>  {" "}<span style={{color:"white",marginLeft:"8px"}}> +91-8470980680</span> 
     </Heading>
     <Heading  display={"flex"} textAlign={"left"} color="green" as="h3" size="sm" id="contact-email">
   <HiOutlineMail  fontSize={"25px"}/> {" "} <span style={{color:"white",marginLeft:"8px"}}> sachin.kesarwani67890@gmail.com</span>   
     </Heading>
     </div> */}
   
    
   </div>
   <Feedback/>
      </div>
   
    </>
  );
};

export default Contact;
